module.exports = __webpack_public_path__ + "static/media/my_cases.4ea1031b.svg";